import React from "react";
import styled from "styled-components";
import DataTableList from "./Components/DataTableList/DataTableList";

function DataListMain() {
  return (
    <Wrapper className="App">
      <DataTableList />
    </Wrapper>
  );
}

export default DataListMain;
const Wrapper = styled.div`
  height: 100vh;
  background-color: #f4f5f7;
  position: relative;
`;
